import { WidgetTypeModel } from '@utmost.co/enterprise-models';
import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type Widget = 'WIDGET' | 'WIDGET_CONFIGURE';

export const widget: Record<Widget, MixpanelEvent> = {
  WIDGET: {
    eventDescription: 'Home Page Widget',
    eventKey: 'home_page_widget',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  },
  WIDGET_CONFIGURE: {
    eventDescription: 'Home Page Widget Configuration',
    eventKey: 'home_page_widget_configure',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  }
} as const;

export type InternalLinkButton = {
  widgetType: WidgetTypeModel;
  linkType: LinkType;
};

export type LinkType =
  | 'ACTIVE_NON_EMPLOYEE_WORKERS'
  | 'ACTIVE_WORKERS'
  | 'EMPLOYEES'
  | 'NON_EMPLOYEES'
  | 'UNKNOWN'
  | 'ACTIVE_SUPPLIERS'
  | 'PROGRAM_ALERT_SEV_WARNING'
  | 'PROGRAM_ALERT_SEV_CRITICAL'
  | 'PROGRAM_ALERT_SEV_ADVISORY'
  | 'PROGRAM_ALERT_TOTAL'
  | 'TIME_TO_FILL_COUNT_AVG'
  | 'TIME_TO_FILL_COUNT_MIN'
  | 'TIME_TO_FILL_COUNT_MAX';
